"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const message_dialog_1 = require("../message-dialog");
const DefaultYesButtonText = "Yes";
const DefaultNoButtonText = "No";
class ConfirmationDialog extends message_dialog_1.default {
    // CAUTION  never ever try to store any dynamic state in a
    // ConfirmationDialog object since it is treated as immutable
    // Currently, solely ActiveModalDialog is known to be capable of
    // representing individual dialog instances.
    constructor(_confirmationDialogConfig = {}) {
        super(_confirmationDialogConfig); // call ModalDialog's constructor
        this._confirmationDialogConfig = _confirmationDialogConfig;
    }
    get yesButtonSelector() {
        const selector = this._confirmationDialogConfig.yesButtonSelector || `.${this.okCloseButton}-button`;
        return `${this.footerSelector} ${selector}`;
    }
    get noButtonSelector() {
        const selector = this._confirmationDialogConfig.noButtonSelector || `.${this.cancelCloseButton}-button`;
        return `${this.footerSelector} ${selector}`;
    }
    get yesButtonText() {
        return this._confirmationDialogConfig.yesButtonText || DefaultYesButtonText;
    }
    get noButtonText() {
        return this._confirmationDialogConfig.noButtonText || DefaultNoButtonText;
    }
    get okCloseButton() {
        return "yes";
    }
    get cancelCloseButton() {
        return "no";
    }
    getButtonMatcher() {
        return clickEvent => {
            if (this.jQuery(clickEvent.target).hasClass(`${this.okCloseButton}-button`)) {
                return this.okCloseButton;
            }
            if (this.jQuery(clickEvent.target).hasClass(`${this.cancelCloseButton}-button`)) {
                return this.cancelCloseButton;
            }
        };
    }
    toString() {
        return `Confirmation Dialog "${this.messageText}"`;
    }
    setContentVisibility(visible) {
        // show my modal buttons
        this.jQuery(this.yesButtonSelector).text(visible ? this.yesButtonText : DefaultYesButtonText);
        this.jQuery(this.noButtonSelector).text(visible ? this.noButtonText : DefaultNoButtonText);
        this.setVisibilityBySelector(this.yesButtonSelector, visible);
        this.setVisibilityBySelector(this.noButtonSelector, visible);
        // show MessageDialog's stuff
        super.setContentVisibility(visible);
    }
}
exports.default = ConfirmationDialog;
